export enum PermissionEnum {
  CREATE = 'C',
  READ = 'R',
  UPDATE = 'U',
  DELETE = 'D',
  EXECUTE = 'E',
}
